module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/intestines-80fcc1ed97e19e8af403be56e867aafe.png";